import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './pages/App';
const root = createRoot(document.getElementById('app'));
root.render(_jsx(App, {}));
